module.exports = __webpack_public_path__ + "static/media/lettuce.2951aa49.svg";